import { PriceTypography, Typography } from '@musinsa/mds';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

const DISPLAY_NAME = 'ProductInformation.ExpectedEarnings';

interface Props {
  expectedEarnings: number;
  className?: string;
}

export const ExpectedEarnings: FC<Props> = ({ expectedEarnings, className }) => (
  <div>
    <Typography
      variant="textEtc11pxReg"
      colorScheme="gray-500"
      className={twMerge('pt-[10px]', className)}
    >
      예상수익{' '}
      {expectedEarnings > 0 ? (
        <PriceTypography
          variant="textEtc11pxReg"
          colorScheme="gray-500"
          weight="regular"
          price={expectedEarnings}
        />
      ) : (
        '0원'
      )}
    </Typography>
  </div>
);

ExpectedEarnings.displayName = DISPLAY_NAME;
